/* eslint-disable max-len */
import Phaser from 'phaser';

import config from '../config';
import pageParams from '../pageParams';
import siteAnimationData from '../data/mazeSiteAnimationData';

// import { Width } from '../../../utils/mediaWidth/mediaWidth';

function closeMazeEntrance(scene, x, y, rect1, rect2) {
    const height = rect1.y1 - rect1.y0;
    const rectangle = scene.add.rectangle(
        x + rect1.x1 - height,
        y + rect1.y0 - height,
        rect2.x0 - rect1.x1 + 2 * height,
        height,
    );
    rectangle.setOrigin(0);
    scene.physics.add.existing(rectangle, true);
    scene.physics.add.collider(scene.ball, rectangle);
}

function drawWall(scene, x, y, maze) {
    maze.forEach(({
        x0, y0, x1, y1,
    }) => {
        const rectangle = scene.add.rectangle(x + x0, y + y0, x1 - x0, y1 - y0);
        rectangle.setOrigin(0);
        scene.physics.add.existing(rectangle, true);
        scene.physics.add.collider(scene.ball, rectangle);
    });

    closeMazeEntrance(scene, x, y, maze[0], maze[1]);
}

function getSize(maze) {
    return maze.reduce((agg, { x1, y1 }) => {
        if (x1 > agg.width && y1 > agg.height) return { height: y1, width: x1 };
        if (x1 > agg.width) return { ...agg, width: x1 };
        if (y1 > agg.height) return { ...agg, height: y1 };
        return agg;
    }, { height: 0, width: 0 });
}

class Maze extends Phaser.GameObjects.Graphics {
    constructor(scene, x, y, maze, shadowOffset, finishParams, isRenderGame) {
        super(scene, { x: 0, y, depth: 5 });

        this.positionX = x;

        scene.add.existing(this);

        this.drawMaze(-shadowOffset, shadowOffset, 0x969696, maze);
        this.drawMaze(0, 0, 0xFFFFFF, maze);

        this.scene = scene;

        this.displayOriginX = 0.5;
        this.displayOriginY = 0.5;

        const { width, height } = getSize(maze);

        this.height = height;
        this.width = width;
        this.finishParams = finishParams;
        this.setAlpha(0);

        if (isRenderGame) {
            drawWall(scene, x, y, maze);
            this.addExit(scene, x, y, maze[4], maze[3]);

            if (pageParams.screenSize === 's' || pageParams.screenSize === 'm') {
                this.setX(x);
            } else {
                this.setX(x - width + maze[1].x0);
            }
        }

        if (pageParams.screenSize === 'l' || pageParams.screenSize === 'xl') {
            this.finishScaleX = this.finishParams.width / this.width;
            this.finishScaleY = this.finishParams.height / this.height;
        }
    }

    addExit(scene, x, y, rect1, rect2) {
        const height = rect1.y1 - rect1.y0;
        this.exit = scene.add.rectangle(
            x + rect1.x1 - height,
            y + rect1.y1,
            rect2.x0 - rect1.x1 + 2 * height,
            height,
        );
        this.exit.setOrigin(0);
        scene.physics.add.existing(this.exit, true);
    }

    drawMaze(x, y, color, maze) {
        this.fillStyle(color, 1);
        maze.forEach(({
            x0, y0, x1, y1,
        }) => this.fillRect(x + x0, y + y0, x1 - x0, y1 - y0));
    }

    show() {
        const delay = 700;
        if (pageParams.screenSize === 's' || pageParams.screenSize === 'm') {
            this.scene.tweens.add({
                targets: this,
                alpha: 1,
                ease: 'Cubic.easeInOut',
                duration: config.startAnimationDuration - delay,
                delay,
            });
        } else {
            // const alphaDuration = 1000;
            // this.scene.tweens.add({
            //     targets: this,
            //     alpha: 1,
            //     ease: 'Cubic.easeInOut',
            //     duration: alphaDuration,
            //     onComplete: () => {
            //         this.scene.tweens.add({
            //             targets: this,
            //             x: this.positionX,
            //             ease: 'Linear',
            //             duration: config.startAnimationDuration - alphaDuration,
            //         });
            //     },
            // });
            this.scene.tweens.add({
                targets: this,
                alpha: 1,
                ease: 'Cubic.easeInOut',
                duration: config.startAnimationDuration - delay,
                delay,
            });
            this.scene.tweens.add({
                targets: this,
                x: this.positionX,
                ease: 'Linear',
                duration: config.startAnimationDuration - delay,
                delay,
            });
        }
    }

    exitAnimation(duration) {
        if (pageParams.screenSize === 's' || pageParams.screenSize === 'm') {
            this.scene.tweens.add({
                targets: this,
                alpha: 0,
                ease: 'Cubic.easeInOut',
                duration,
            });
        } else {
            // const scale = this.finishParams.sideSize / this.height;
            // const left = config.width === 1440 ? 900 : this.finishParams.left;
            // const top = config.width === 1440 ? -150 : this.finishParams.top;
            this.scene.tweens.add({
                targets: this,
                scaleX: this.finishScaleX,
                scaleY: this.finishScaleY,
                x: 2 * pageParams.offsetLeft + this.finishParams.left + Math.round((this.width * this.finishScaleX) / 2),
                y: pageParams.offsetTop + this.finishParams.top + Math.round(this.height * (1 - this.finishScaleY / 2)),
                angle: 45,
                ease: 'Cubic.easeInOut',
                duration,
            });
        }
    }

    getMainPagePosition() {
        this.setScale(this.finishScaleX, this.finishScaleY);
        this.setX(pageParams.offsetLeft + this.finishParams.left + Math.round((this.width * this.finishScaleX) * (Math.sqrt(2) / 2)));
        this.setY(pageParams.offsetTop + this.finishParams.top + Math.round(this.height * (1 - this.finishScaleY / 2)));
        this.setAngle(45);
        this.setAlpha(1);
    }

    mainPageAnimation(callback) {
        this.setScale(this.finishScaleX, this.finishScaleY);
        this.setX(pageParams.clientWidth + Math.round((this.width * this.finishScaleX) * (Math.sqrt(2) / 2)));
        this.setY(pageParams.offsetTop + this.finishParams.top + Math.round(this.height * (1 - this.finishScaleY / 2)));
        this.setAngle(45);

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            x: pageParams.offsetLeft + this.finishParams.left + Math.round((this.width * this.finishScaleX) * (Math.sqrt(2) / 2)),
            ease: 'Cubic.easeOut',
            duration: config.siteAnimationDuration.main,
            onComplete: () => {
                if (callback) callback();
            },
        });
    }

    getPositionCenter(x, y, angle) {
        this.setAlpha(0);
        this.setScale(1, 1);
        this.setX(x);
        this.setY(y);
        this.setAngle(angle);
    }

    researchPageAnimation(callback) {
        const {
            research: {
                startAngle,
                finishAngle,
                top,
                left,
            },
        } = siteAnimationData[pageParams.screenSize];

        this.getPositionCenter((pageParams.clientWidth - this.width) / 2, (pageParams.clientHeight - this.height) / 2, startAngle);
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: 'Cubic.easeInOut',
            duration: config.siteAnimationDuration.direction.mazeOpacity,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this,
                    angle: finishAngle,
                    scaleX: this.finishScaleX,
                    scaleY: this.finishScaleY,
                    x: pageParams.offsetLeft + left,
                    y: 2 * pageParams.offsetTop + top + this.width * this.finishScaleX,
                    ease: 'Cubic.easeInOut',
                    duration: config.siteAnimationDuration.direction.mazeMoving,
                    onComplete: () => {
                        if (callback) callback();
                    },
                });
            },
        });
    }

    designPageAnimation(callback) {
        const {
            design: {
                startAngle,
                finishAngle,
                top,
                left,
            },
        } = siteAnimationData[pageParams.screenSize];

        this.getPositionCenter((pageParams.clientWidth - this.height) / 2, this.width + (pageParams.clientHeight - this.width) / 2, startAngle);
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: 'Cubic.easeInOut',
            duration: config.siteAnimationDuration.direction.mazeOpacity,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this,
                    angle: finishAngle,
                    scaleX: this.finishScaleX,
                    scaleY: this.finishScaleY,
                    x: pageParams.offsetLeft + left + this.width * this.finishScaleX,
                    y: 2 * pageParams.offsetTop + top + this.height * this.finishScaleY,
                    ease: 'Cubic.easeInOut',
                    duration: config.siteAnimationDuration.direction.mazeMoving,
                    onComplete: () => {
                        if (callback) callback();
                    },
                });
            },
        });
    }

    launchPageAnimation(callback) {
        const {
            launch: {
                startAngle,
                finishAngle,
                top,
                left,
            },
        } = siteAnimationData[pageParams.screenSize];

        this.getPositionCenter((pageParams.clientWidth + this.height) / 2, (pageParams.clientHeight - this.width) / 2, startAngle);
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: 'Cubic.easeInOut',
            duration: config.siteAnimationDuration.direction.mazeOpacity,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this,
                    angle: finishAngle,
                    scaleX: this.finishScaleX,
                    scaleY: this.finishScaleY,
                    x: pageParams.offsetLeft + left,
                    y: 2 * pageParams.offsetTop + top,
                    ease: 'Cubic.easeInOut',
                    duration: config.siteAnimationDuration.direction.mazeMoving,
                    onComplete: () => {
                        if (callback) callback();
                    },
                });
            },
        });
    }
}

export default Maze;
